import { SPACE_BLUE_GRADIANT_THEME_ID } from "segments/segments-service";

export default {
  theme: SPACE_BLUE_GRADIANT_THEME_ID,
  introText: "Pick up where you left off"
};
